export const calendar = 'https://images.contentstack.io/v3/assets/blt06f605a34f1194ff/blt234df6e6b520e8c8/5e6bb7c566949b18b0cf0540/icon-calendar.svg';

export const duration = 'https://images.contentstack.io/v3/assets/blt06f605a34f1194ff/blt56797084b4e2d295/5e6bb7d58c83c26c32eb0bfa/icon-duration.svg';

export const heart = 'https://images.contentstack.io/v3/assets/blt06f605a34f1194ff/blt054c706d0acb19ee/5e6bb7e5b163ab6cedfa1c6d/icon-heart.svg';
